import {Component, Input, OnInit} from '@angular/core';
import {TitleConfigurations, TitleLineConfigurations} from '../title/title.configurations';
import {KlaHttpService} from '../services/kla.http.service';
import {CropConfiguration} from '../indicator-basic/crop-configuration';
import {Image} from '../services/kla.data.models';
import { CommonModule } from '@angular/common';
import { ImageObjectComponent } from '../image-object/image-object.component';
import { BadgesComponent } from '../badges/badges.component';
import { SocialMediaButtonsComponent } from '../social-media-buttons/social-media-buttons.component';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-simple-image',
  templateUrl: './simple-image.component.html',
  styleUrls: ['./simple-image.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, ImageObjectComponent, BadgesComponent, SocialMediaButtonsComponent, StripSpecialCharsPipe, DynamicContentComponent]
})
export class SimpleImageComponent implements OnInit {

  @Input()
  public image: string;

  @Input()
  public imagePosition = 'left';

  @Input()
  public titleConfigurations: TitleConfigurations;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public cropConfig: CropConfiguration;

  @Input()
  public imageObject: Image;

  public imagePath;

  get imageWidthFromInput() {
    return this.titleConfigurations.imageWidth;
  }

  get imageHeight() {
    return this.titleConfigurations.imageHeight + 'px';
  }
  get imageWidth() {
    if(this.imagePosition == 'full-width' && !this.titleConfigurations.imageWidth) {
      return '100%';
    }
    if(!this.titleConfigurations.imageWidth) {
      return '380px';
    }
    if(window.innerWidth < this.titleConfigurations.imageWidth || window.innerWidth < 992) {
      return '100%';
    }
    return this.titleConfigurations.imageWidth + 'px';
  }

  get displayWidth() {
    return window.innerWidth;
  }

  constructor(private httpService: KlaHttpService) {}

  ngOnInit() {
    this.imageObject.width = this.imagePosition == 'full-width' ? 1400 : 900;
    const imageConfig: Image = {
      id: this.imageObject.id,
      width: +this.imageObject.width,
      height: +this.imageObject.height,
      cropConfig: this.imageObject.crop_config
    };

    if (imageConfig.cropConfig && (imageConfig.width || imageConfig.height)) {
      this.imagePath = this.httpService.getCroppedImagePath(imageConfig);
    } else {
      this.imagePath = this.httpService.getImagePath(imageConfig.id, imageConfig.width);
    }
  }
}
